import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const studyHistoryFields: FieldInterface[] = [
  {
    key: 'createdAt',
    originKey: 'created_at',
    type: FIELD_TYPES.date,
  },
  {
    key: 'event',
    originKey: 'event',
    objectType: 'StudyHistoryModelEvent',
    objectTypePath: 'src/services/mappings/study/studyHistory.types',
    type: FIELD_TYPES.object,
  },
  {
    key: 'lever',
    originKey: 'lever',
    type: FIELD_TYPES.string,
  },
  {
    key: 'previousStepId',
    originKey: 'previous_step_id',
    type: FIELD_TYPES.string,
  },
]

export const studyHistoryRelations: RelationInterface[] = [
  {
    key: '_wealthRecommendationProducts',
    originKey: 'wealth_recommendation_products',
    objectType: OBJECT_TYPES.products,
    isMultiple: true,
  },
]
